<template>
  <el-col>
    <el-row
      v-for="type in Object.keys(selection)"
      v-if="type !== 'selected'"
      :key="`${type}-count`"
      type="flex"
      align="middle"
      justify="start"
      style="padding: 6px 0;">
      <el-col :span="12">
        <el-row type="flex" justify="end" align="middle" class="selection-counter">
          {{ getTabLabel(type) }}:
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="center" align="middle" class="selection-counter">
          {{ `${selectionTotals[type]}` }}
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row type="flex" justify="end" align="middle" class="selection-counter text-right">
          {{ `${moneyTotals[type] ? currencySymbol : ''}${moneyTotals[type]}` }}
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
  import { formatLocale } from '@/utils/helpers/StringsNumbers'

  export default {
    props: {
      selection: {
        'type': Object,
        'required': true
      },
      currency: {
        'type': Object,
        'required': false
      },
      getTabLabel: {
        'type': Function,
        'required': true
      }
    },
    computed: {
      selectionTotals () {
        let totals = {}
        for (let type in this.selection) {
          totals[type] = this.selection[type].length
        }
        return totals
      },
      /**
       * Returns the monetary totals of each selection type
       * @return {object}
       */
      moneyTotals () {
        let totals = {}
        for (let type in this.selection) {
          let total = this.selection[type].reduce((a, b) => a + parseFloat(b.amount_decimal), 0)
          if (this.selection[type].length && (total || total === 0) && !isNaN(total)) {
            totals[type] = formatLocale(total.toFixed(2))
          } else {
            totals[type] = ''
          }
        }
        return totals
      },
      /**
       * Returns the currency symbol
       * @return {string}
       */
      currencySymbol () {
        return this.currency && this.currency.symbol ? this.currency.symbol : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Programs/BankRecon/BankRecSelectionSummary.vue